{{#if pagination.html}}
<div class="row m-b-5">
	<div class="col-lg-12">
		<div class="pull-left">{{{pagination.html}}}</div>
		{{#unless valueFilter}}
		{{#unless message}}
		{{#COMPARE deviceCount '!=' allDeviceCount}}
		<div id="overviewDeviceCount" class="pull-left m-l-10 m-t-5">{{TR "Geräte"}}: {{deviceCount}} / {{allDeviceCount}}</div>
		{{/COMPARE}}
		{{/unless}}
		{{/unless}}
	</div>
</div>
{{/if}}
<div class="row">
	<div class="col-lg-12">
		{{#if message}}
		{{{message}}}
		{{else}}
		<div class="row">
			{{#each devices}}
			{{> 'OVERVIEW_PANEL' this}}
			{{/each}}
		</div>
		{{/if}}
	</div>
</div>

